import React, { useState } from "react";
import "./DoomsdayDozen.scss";
import DoomsdayChart from "./DoomsdayChart";
import DoomsdayTable from "./DoomsdayTable";
import "./DoomsdayDozen.scss";
import { API, graphqlOperation } from "aws-amplify";
import ReusableDropdown from "_shared/components/ReusableDropdown";
import ReactTooltip from "react-tooltip";
import Loading from "_shared/components/Loading/Loading";

export default function DoomsdayDozen(props) {
  const [chart, setChart] = useState("All");
  const [fullScreen, setFullScreen] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [handler, setHandler] = React.useState("");

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  const keyMap = {
    "FEAR/GREED SIGNAL": "FEAR_GREED_SCORE",
    "MARKET MOMENTUM": "SPX_INDEX",
    "MARKET STRENGTH": "STK_PX_STRNGTH_PERC_HIGH_OF_TOT_5_DAY",
    "MARKET BREADTH": "SUM_INX_INDEX",
    "EQUITY PUT/CALL RATIO": "PUT_CALL_5DAVE",
    VOLATILITY: "VIX_INDEX",
    "JUNK BOND DEMAND": "HY_IG_G_INDEX",
    "SAFE HAVEN DEMAND": "SAFE_SCORE_5DMA",
    "VVIX/VIX": "VVIX_OVER_VIX",
    "MONTHLY PMI": "MPMIGLCA_INDEX",
    "YIELD INVERSION": "YLD_10_MIN_2",
  };

  const indexMap = {
    "MARKET MOMENTUM": "MAVE_125D",
  };

  React.useEffect(() => {
    const async = async () => {
      const data = (
        await API.graphql(
          graphqlOperation(`{
        python_scripts_cache_by_pk(id: "doomsday") {
          data
        }
      }
      `),
        )
      ).data.python_scripts_cache_by_pk.data;

      data["DATE"].reverse();
      data["FEAR_GREED_FINAL_SCORE"] = data["FEAR_GREED_SCORE"][0];
      [...Object.values(keyMap), "DOOMSDAY_SCORE"].forEach((value) =>
        data[value]?.reverse(),
      );
      Object.values(indexMap).forEach((index) => data[index]?.reverse());
      setData(data);
      setIsLoading(false);
      ReactTooltip.rebuild();
    };
    async();
  }, []);

  return (
    <div className="dashboard-content" style={{ marginTop: -40 }}>
      <div className="doomsday-dozen">
        <div className="column table-section">
          <DoomsdayTable data={data} reload={props.reload} />
        </div>
      </div>
      <div className="doomsday-dozen">
        {isLoading ? (
          <Loading />
        ) : (
          <div className="column chart-section">
            {!window.matchMedia("(max-width: 480px)").matches ? (
              <div className="dozen-tabs">
                <div
                  onClick={() => {
                    setChart("All");
                    setFullScreen(false);
                  }}
                  className={`tabs ${chart === "All" ? "selected" : ""}`}
                >
                  All
                </div>
                <div
                  onClick={() => {
                    setChart("Fear/Greed Signal");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Fear/Greed Signal" ? "selected" : ""
                  }`}
                >
                  Fear/Greed Signal
                </div>
                <div
                  onClick={() => {
                    setChart("Market Momentum");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Market Momentum" ? "selected" : ""
                  }`}
                >
                  Market Momentum
                </div>
                <div
                  onClick={() => {
                    setChart("Market Strength");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Market Strength" ? "selected" : ""
                  }`}
                >
                  Market Strength
                </div>
                <div
                  onClick={() => {
                    setChart("Market Breadth");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Market Breadth" ? "selected" : ""
                  }`}
                >
                  Market Breadth
                </div>
                <div
                  onClick={() => {
                    setChart("Equity Put/Call Ratio");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Equity Put/Call Ratio" ? "selected" : ""
                  }`}
                >
                  Equity Put/Call Ratio
                </div>
                <div
                  onClick={() => {
                    setChart("Volatility");
                    setFullScreen(true);
                  }}
                  className={`tabs ${chart === "Volatility" ? "selected" : ""}`}
                >
                  Volatility
                </div>
                <div
                  onClick={() => {
                    setChart("Junk Bond Demand");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Junk Bond Demand" ? "selected" : ""
                  }`}
                >
                  Junk Bond Demand
                </div>
                <div
                  onClick={() => {
                    setChart("Safe Haven Demand");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Safe Haven Demand" ? "selected" : ""
                  }`}
                >
                  Safe Haven Demand
                </div>
                <div
                  onClick={() => {
                    setChart("VVIX/VIX");
                    setFullScreen(true);
                  }}
                  className={`tabs ${chart === "VVIX/VIX" ? "selected" : ""}`}
                >
                  VVIX/VIX
                </div>
                <div
                  onClick={() => {
                    setChart("Monthly PMI");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Monthly PMI" ? "selected" : ""
                  }`}
                >
                  Monthly PMI
                </div>
                <div
                  onClick={() => {
                    setChart("Yield Inversion");
                    setFullScreen(true);
                  }}
                  className={`tabs ${
                    chart === "Yield Inversion" ? "selected" : ""
                  }`}
                >
                  Yield Inversion
                </div>
              </div>
            ) : (
              <div style={{ cursor: "pointer" }}>
                <ReusableDropdown
                  title="Chart Dropdown"
                  selectedDropdown={chart}
                  list={[
                    "All",
                    "Fear/Greed Signal",
                    "Market Momentum",
                    "Market Strength",
                    "Market Breadth",
                    "Equity Put/Call Ratio",
                    "Volatility",
                    "Junk Bond Demand",
                    "Safe Haven Demand",
                    "VVIX/VIX",
                    "Monthly PMI",
                    "Yield Inversion",
                  ]}
                  className="dropdown-brokerage-mobile"
                  handleDropdown={(value) => {
                    setChart(value);
                    if (value !== "All") setFullScreen(true);
                    else setFullScreen(false);
                  }}
                />
              </div>
            )}
            <div
              style={{
                display: window.matchMedia("(max-width: 480px)").matches
                  ? "block"
                  : "flex",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
              }}
            >
              {[
                {
                  title: "FEAR/GREED SIGNAL",
                  info: "Longbow proprietary Fear/Greed Signal",
                  key: keyMap["FEAR/GREED SIGNAL"],
                  yAxis: "Score 0-100",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'FEAR_GREED_SCORE',
                  showGradient: true,
                },
                {
                  title: "MARKET MOMENTUM",
                  info: "SPX Index (white) and its 125-day moving average (blue)",
                  key: keyMap["MARKET MOMENTUM"],
                  yAxis: "SPX Index",
                  index: indexMap["MARKET MOMENTUM"],
                  labelsExist: false,
                  labelsReverse: false,
                  showGradient: false,
                },
                {
                  title: "MARKET STRENGTH",
                  info: "Rolling 5-day average of % stocks trading at 52 week high versus low",
                  key: keyMap["MARKET STRENGTH"],
                  yAxis: "",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'STK_PX_STRNGTH_SCORE',
                  showGradient: true,
                },
                {
                  title: "MARKET BREADTH",
                  info: "SUM INX Index",
                  key: keyMap["MARKET BREADTH"],
                  yAxis: "McClellans Adv – Decl US Index px",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'STK_PX_BREADTH_SCORE',
                  showGradient: false,
                },
                {
                  title: "EQUITY PUT/CALL RATIO",
                  info: "5 DMA of PCUSEQTR Index",
                  key: keyMap["EQUITY PUT/CALL RATIO"],
                  yAxis: "CBOE Ratio",
                  labelsExist: true,
                  labelsReverse: true,
                  // index: 'PUT_CALL_SCORE',
                  showGradient: false,
                },
                {
                  title: "VOLATILITY",
                  info: "VIX Index",
                  key: keyMap["VOLATILITY"],
                  yAxis: "VIX Index",
                  labelsExist: true,
                  labelsReverse: true,
                  // index: 'VOL_SCORE',
                  showGradient: false,
                },
                {
                  title: "JUNK BOND DEMAND",
                  info: "HY_IG_G_INDEX",
                  key: keyMap["JUNK BOND DEMAND"],
                  yAxis: "",
                  labelsExist: true,
                  labelsReverse: true,
                  // index: 'JUNK_SCORE',
                  showGradient: false,
                },

                {
                  title: "SAFE HAVEN DEMAND",
                  info: "5 DMA of Safe Haven Demand score",
                  key: keyMap["SAFE HAVEN DEMAND"],
                  yAxis: "",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'SAFE_SCORE',
                  showGradient: false,
                },
                {
                  title: "VVIX/VIX",
                  info: "VVIX/VIX Ratio",
                  key: keyMap["VVIX/VIX"],
                  yAxis: "VVIX/VIX Ratio",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'VVIX_SCORE',
                  showGradient: false,
                },
                {
                  title: "MONTHLY PMI",
                  info: "MPMIGLCA Index",
                  key: keyMap["MONTHLY PMI"],
                  yAxis: "MPMIGLCA Index",
                  labelsExist: false,
                  labelsReverse: false,
                  // index: 'INVERSION_SCORE',
                  showGradient: false,
                },
                {
                  title: "YIELD INVERSION",
                  info: "UST 10 Year Yields – UST 2 Year Yields",
                  key: keyMap["YIELD INVERSION"],
                  yAxis: "UST 10Yr-2Yr Yield",
                  labelsExist: true,
                  labelsReverse: false,
                  // index: 'INVERSION_SCORE',
                  showGradient: false,
                },
              ].map((obj) => {
                if (
                  fullScreen &&
                  obj.title.toUpperCase() !== chart.toUpperCase()
                ) {
                  return <div />;
                } else {
                  return (
                    <DoomsdayChart
                      key={obj.key}
                      title={obj.title}
                      info={obj.info}
                      dates={data.DATE} //ascending order
                      values={data[obj.key]} //ascending order
                      indexes={
                        obj.title === "YIELD INVERSION"
                          ? Array.apply(null, Array(365)).map(
                              Number.prototype.valueOf,
                              0.2,
                            )
                          : obj.index
                          ? data[obj.index]
                          : []
                      }
                      labelsExist={obj.labelsExist}
                      labelsReverse={obj.labelsReverse}
                      yAxis={obj.yAxis}
                      fullScreen={fullScreen}
                      showGradient={obj.showGradient}
                      signal={data}
                    />
                  );
                }
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
